const _rootUrl = process.env.VUE_APP_ROOT_DOMAIN || 'https://quicksend.asia';


export default {
  rootUrl: function (path='') {
    if (_rootUrl.endsWith('/')) {
      return `${_rootUrl}#${path}`;
    } else {
      return `${_rootUrl}/#${path}`;
    }
  },

  subdomainUrl: function (subdomain, path='') {
    let url = new URL(_rootUrl);
    let port = url.port !== '' ? `:${url.port}`: '';
    return `${url.protocol}//${subdomain}.${url.hostname}${port}/#${path}`;
  },

  rootDomain: () => {
    let url = new URL(_rootUrl);
    return url.hostname;
  },

  rawRedirect: function (path='') {
    window.location.href = this.rootUrl(path);
    window.location.reload();
  },

  rawRedirectSubdomain: function (subdomain, path='') {
    window.location.href = this.subdomainUrl(subdomain, path);
    window.location.reload();
  }
}
